/**
 * Carrier logo path helper.
 *
 * Every carrier partner has a logo at `public/assets/carrier-<slug>.<ext>`.
 * Most are the redesign's `.webp` marks; carriers we've since upgraded to a
 * higher-quality source use `.svg` (vector — sharp at any size) or a high-res
 * `.png`. This resolves the right extension per slug so the hero orbits, the
 * carrier directory, and the partner pages all point at the best asset.
 *
 * To upgrade a carrier: drop the new file at carrier-<slug>.svg|png in
 * public/assets, remove the old carrier-<slug>.webp, and add its slug below.
 */
const SVG_LOGOS = new Set([
    "aetna-cvs-health",
    "cigna-healthcare",
    "devoted-health",
    "humana",
    "oscar",
    "select-health",
    "wellcare",
]);

const PNG_LOGOS = new Set([
    "allstate-health-solutions",
    "blue-cross-blue-shield-of-arizona",
    "blue-cross-blue-shield-of-montana",
    "blue-cross-blue-shield-of-new-mexico",
    "blue-cross-blue-shield-of-oklahoma",
    "blue-cross-blue-shield-of-texas",
    "ncd",
    "university-of-utah-health",
    "wellabe",
    "wellpoint",
    "zing-health",
]);

// Stopgap: no high-res *wordmark* was available for these, but we have a crisp
// square brand icon (public/assets/carrier-icons/<slug>.png). Use the icon in
// the logo slots rather than leave a blurry upscaled wordmark. Swap each slug
// out of this set (into SVG/PNG above) once a real wordmark is sourced.
const ICON_FALLBACK = new Set([
    "ambetter-health",
    "blue-cross-blue-shield-of-north-carolina",
    "florida-blue",
    "united-healthcare-golden-rule-insurance-co",
]);

export function carrierLogo(slug: string): string {
    if (ICON_FALLBACK.has(slug)) return `/assets/carrier-icons/${slug}.png`;
    const ext = SVG_LOGOS.has(slug) ? "svg" : PNG_LOGOS.has(slug) ? "png" : "webp";
    return `/assets/carrier-${slug}.${ext}`;
}
